<template>
  <div class="page-content-wrapper" v-check-permission="'edit-stock-of-ambos'">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="card m-b-20">
            <div class="card-block">
              <h4 class="mt-0 header-title">Stock de ambos</h4>

              <template v-if="item">

                <div class="form-group  mb-3" v-bind:class="{ 'has-danger': $v.item.name.$error }">
                  <label>Nombre de la prenda</label>
                  <input type="text" class="form-control col-md-6" v-model="item.name" @input="$v.item.name.$touch()">
                  <div class="form-control-feedback" v-if="!$v.item.name.required && $v.item.name.$error">El nombre es requerido.</div>
                </div>

                <!--div class="form-group  mb-3">
                  <label>Descripción</label>
                  <textarea class="form-control col-md-6" v-model="item.description"></textarea>
                </div-->

                <div class="form-group mb-3" v-bind:class="{ 'has-danger': $v.item.career.$error }">
                  <label>Carrera</label>
                  <div class="col-md-6" style="padding-left: 0;">
                    <select id="career" class="custom-select form-control" v-model="item.career">
                      <option v-for="career in careers" v-bind:value="career._id">
                        {{ career.name }}
                      </option>
                    </select>
                  </div>
                  <div class="form-control-feedback" v-if="!$v.item.career.required && $v.item.career.$error">Seleccione una carrera.</div>
                </div>

                <div class="form-group mb-3" v-bind:class="{ 'has-danger': $v.item.size.$error }">
                  <label>Talle</label>
                  <div class="col-md-6" style="padding-left: 0;">
                    <select id="size" class="custom-select form-control" v-model="item.size">
                      <option v-for="size in sizes" :value="size.value">{{ size.text }}</option>
                    </select>
                  </div>
                  <div class="form-control-feedback" v-if="!$v.item.size.required && $v.item.size.$error">Seleccione un talle.</div>
                </div>

                <div class="row">
                  <div class="form-group col-md-3 mb-3" v-bind:class="{ 'has-danger': $v.item.price.$error }">
                    <label>Precio unitario</label>
                    <input type="number" min="1" class="form-control" v-model="item.price" @input="$v.item.price.$touch()">
                    <div class="form-control-feedback" v-if="!$v.item.price.required && $v.item.price.$error">El precio es requerido.</div>
                    <div class="form-control-feedback" v-if="!$v.item.price.minValue && $v.item.price.$error">El monto mínimo aceptado es 1.</div>
                    <small>Ingresar el precio unitario.</small>
                  </div>

                  <div class="form-group col-md-3 mb-3"  v-bind:class="{ 'has-danger': $v.item.amount.$error }">
                    <label>Cantidad en stock</label>
                    <input type="number" min="0" class="form-control" v-model="item.amount">
                    <div class="form-control-feedback" v-if="!$v.item.amount.required && $v.item.amount.$error">La cantidad en stock es requerida.</div>
                    <div class="form-control-feedback" v-if="!$v.item.amount.minValue && $v.item.amount.$error">La cantidad en stock mínima aceptada es 0.</div>
                    <small>Ingresar la cantidad en stock.</small>
                  </div>
                </div>


                <!--div class="form-group  m-b-0">
                  <label>Estado</label>
                  <div>
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" v-model="item.active">
                      <span class="custom-control-indicator"></span>
                      <span class="custom-control-description">Activo</span>
                    </label>
                  </div>
                </div-->


                <div class="card-block pull-right pr-0">
                  <router-link to="/list-stock-of-ambos" class="btn btn-secondary waves-effect m-r-10">Cancelar</router-link>
                  <a href="javascript:void(0);" class="btn btn-primary waves-effect waves-light save-btn" @click="submit()">Guardar</a>
                </div>

              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { required, minValue } from 'vuelidate/lib/validators'
  import sizes from '../data/sizes'

  export default {
    name: 'edit-item-of-stock-of-ambos',




    created () {
      this.getAllCareers();
      this.getItemOfStockOfAmbos();
    },




    data () {
      return {
        sizes: sizes
      }
    },




    computed: {
      item: function () {
        return this.$store.getters.getItemOfStockOfAmbos
      },

      careers: function () {
        return this.$store.getters.getAllCareers
      }
    },




    validations: {
      item: {
        name: {
          required
        },
        career: {
          required
        },
        size: {
          required
        },
        price: {
          required,
          minValue: minValue(1)
        },
        amount: {
          required,
          minValue: minValue(0)
        },
      }
    },




    methods: {

      getItemOfStockOfAmbos: function () {
        this.$loader.loading();

        this.$store.dispatch('getItemOfStockOfAmbos', { id : this.$route.params.id })
          .then((response) => {
            this.$loader.close();
          })
          .catch(error => {
            this.$message.error({text: error})
          })
      },



      getAllCareers () {
        this.$loader.loading();

        this.$store.dispatch('getAllCareers')
          .then((response) => {
            this.$loader.close();
          })
          .catch((response) => {
            this.$loader.close();
          })
      },




      submit: function () {
        const self = this
        this.$v.item.$touch()

        if(!this.$v.item.$error) {
          $('.save-btn').attr('disabled', true);

          this.$store.dispatch('editItemOfStockOfAmbos', {item: this.item})
            .then((response) => {

              if(response.success) {
                self.$message.success({text: response.message});

                setTimeout(function () {
                  self.$router.push('/list-stock-of-ambos')
                }, 500)
              } else {
                self.$message.error({text: response.message});
              }

              $('.save-btn').attr('disabled', false)
            })
            .catch((response) => {
              self.$message.error({text: response.message});
              $('.save-btn').attr('disabled', false)
            })
        }
      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/screens/EditItemOfStockOfAmbosScreen.vue